<template>
  <MaterialListSlots
    :dataList="list"
    :loadingStatus="loadingStatus"
    :is-collect="isCollect"
    @itemClick="handleClick"
  >
    <slot />
    <template #item="{ item }">
      <div
        class="material-selection-marker"
        :class="{
          'material-selection-marker--checked':
            myMateriaChecked && myMateriaCheckedList.includes(item.id),
          'material-selection-marker--hidden': !myMateriaChecked
        }"
      />
      <a-checkbox
        :checked="myMateriaChecked && myMateriaCheckedList.includes(item.id)"
        class="material-check"
        :class="{ 'material-check--hidden': !myMateriaChecked }"
        @change="checkMaterial(item)"
      />
      <template v-if="!myMateriaChecked">
        <material-popover
          v-if="mine && !liFisherActive"
          :top="item.topping"
          @top="handleTop(item)"
          @delete="handleDelete(item)"
          @tag="showMaterialModel(item, 'tag')"
          @prop="showMaterialModel(item, 'prop')"
        />
        <span
          v-else-if="!mine"
          @click.stop="starClick(item)"
          class="tem_used_icon"
          :class="{ block: item.is_collect }"
          :title="item.is_collect ? '取消收藏' : '收藏'"
          :style="{
            'background-image': item.is_collect
              ? 'url(/preview/icon/icon_collected.png)'
              : 'url(/preview/icon/icon_collect.png)'
          }"
        ></span>
      </template>
    </template>
    <template slot="modal">
      <a-modal
        title="素材属性"
        v-model="propVisible"
        width="500px"
        :footer="false"
        centered
      >
        <a-row type="flex" :gutter="[20, 20]">
          <a-col class="material-prop-label" :span="5">素材类型:</a-col>
          <a-col :span="19">{{
            { 1: "图片", 2: "视频", 6: "音频" }[selectMaterial.material_type] ||
            "未知"
          }}</a-col>
          <a-col class="material-prop-label" :span="5">素材名称:</a-col>
          <a-col :span="19">{{ selectMaterial.material }}</a-col>
          <a-col class="material-prop-label" :span="5">素材大小:</a-col>
          <a-col :span="19">{{
            material_size(selectMaterial.material_size)
          }}</a-col>
          <a-col class="material-prop-label" :span="5">上传时间:</a-col>
          <a-col :span="19">{{ selectMaterial.created_at }}</a-col>
        </a-row>
      </a-modal>
      <material-tag-modal
        :visible.sync="tagVisible"
        :options="tags_option_list"
        :tags="currentTagsList"
        @search="handleTagSearch"
        @select="tagscreate"
        @delete="delTag"
        :deletable="selectMaterial.id"
      />
    </template>
  </MaterialListSlots>
</template>

<script>
import { Empty, message, Modal } from "ant-design-vue";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  getImageAspectRatio,
  getVideoAspectRatio,
  isMac
} from "../../utils";
import MaterialTagModal from './MaterialTagModal';
import MaterialPopover from "./MaterialPopover";
import MaterialListSlots from './MaterialListSlots';

export default {
  name: "materialStyleList",
  props: ['dataList', 'loadingStatus', 'fn', 'replace', 'editStatus', 'handleStampUrl', 'mine', 'isCollect', 'liFisherActive'],
  components: { MaterialPopover, MaterialListSlots, MaterialTagModal },
  data() {
    return {
      propVisible: false,
      tagVisible: false,
      selectMaterial: {},
      likeLookup: {},
      defaultImage: Empty.PRESENTED_IMAGE_SIMPLE,
      // 打标签
      selectIds: '', // 批量选中的素材id
      tags_option_list: [],
      batchTags: [], // 已批量添加的标签
    };
  },
  methods: {
    ...mapActions([
      "delCollect",
      "addCollect",
      "updateMateriaTag",
      "batchUpdateMateriaTag",
      "searchMateriaTag",
      "delMateriaTag"
    ]),
    ...mapMutations([
      "handleStampEnabled",
      "handleCurrentMenu",
      "handleCurrentIcon",
      'handleMyMateriaChecked'
    ]),
    checkMaterial(item) {
      if (!this.myMateriaChecked) {
        this.handleMyMateriaChecked(true)
      }
      let isCheckIndex = -1
      this.myMateriaCheckedList.forEach((mid, index) => {
        if (mid == item.id) {
          isCheckIndex = index
        }
      });
      if (isCheckIndex != -1) {
        this.myMateriaCheckedList.splice(isCheckIndex, 1)
        console.log(this.myMateriaCheckedList)
      } else {
        this.myMateriaCheckedList.push(item.id)
      }
      if (!this.myMateriaCheckedList.length) {
        this.handleMyMateriaChecked(false);
      }
      // this.handleMyMateriaCheckedList(this.myMateriaCheckedList)
    },
    async handleClick({ item, event: e }) {
      let ratio;
      let videoDuration;
      if (this.mine && (isMac && e.metaKey || e.ctrlKey || this.myMateriaChecked)) {
        this.checkMaterial(item);
        return;
      }
      this.$store.commit("handleLoading", true);

      try {
        switch (+item.material_type) {
          case 1:
            // image
            ratio = await getImageAspectRatio(item.material_url);
            break;

          case 2:
            ratio = await getVideoAspectRatio(item.material_url, (video) => {
              videoDuration = video.duration * 1e3;
            });
            break;
        }
      } catch (e) {
        Modal.error({
          title: '素材加载出错',
          content: '素材资源或网络连接可能存在问题。'
        });
        this.$store.commit("handleLoading", false);
        return;
      }
      this.$store.commit("handleLoading", false);
      if (this.currentSubmenu === "ImageStampInfo") {
        if (+item.material_type !== 1) {
          message.error('只能选择图片作为水印');
          return;
        }
        this.handleStampUrl([item.material_url, ratio]);
        this.handleStampEnabled(true);
        this.handleCurrentMenu("StampMenu"); // FIXME: switch back to stamp menu.
        this.handleCurrentIcon("stamp");
        return;
      }
      const func = this.editStatus ? this.replace : this.fn;
      func({
        url: item.material_url,
        material_type: item.material_type,
        name: item.material,
        ratio,
        ownDuration: videoDuration,
        id: item.id
      });
    },
    showMaterialModel: function (selectMaterial, type) {
      this.selectMaterial = selectMaterial;
      switch (type) {
        case "tag":
          this.tagVisible = true;
          break;
        case "prop":
          this.propVisible = true;
          break;
      }
    },
    showMaterialAddTags(ids) {
      this.tagVisible = true;
      this.selectIds = ids;
    },
    handleTop(item) {
      this.$emit("top", {
        id: item.id,
        value: !item.topping,
      });
    },
    handleDelete(item) {
      this.$emit("delete", { id: item.id });
    },
    // 点击收藏
    async starClick(item) {
      if (item.is_collect) {
        // 取消
        await this.delCollect({ type: "material", id: item.id });
        this.$set(this.likeLookup, item.id, false);
      } else {
        // 收藏
        let data = {
          type: "material",
          id: item.id,
          material: item.material,
          material_url: item.material_url,
          material_type: item.material_type,
        };
        if (item.width) {
          data.width = item.width;
        }
        if (item.height) {
          data.height = item.height;
        }
        if (item.duration) {
          data.duration = item.duration;
        }
        await this.addCollect(data);
        this.$set(this.likeLookup, item.id, true);
      }
    },
    handleTagSearch({ value: name, resolve }) {
      resolve(this.material_tags_search(name));
    },
    tagscreate({ value: label, resolve }) {
      resolve(this.addTagToMaterial(label));
    },
    /* 更新标签 */
    addTagToMaterial(labelParam) {
      this.tags_option_list = [];
      let id = this.selectMaterial.id;
      let label = labelParam;
      var reg = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
      if (!label) {
        return;
      }
      if (reg.test(label)) {
        if (id) {
          let arr = this.list;
          let length = 0;
          for (let z = 0; z < arr.length; z++) {
            if (id == arr[z].id) {
              length = arr[z].label.length;
            }
          }
          if (length >= 100) {
            this.$message({
              message: "当前标签已超过100个!",
              type: "warning",
              duration: 3000
            });
            return;
          }
          return this.material_tags_update(id, label);
        }
        return this.material_batch_tags_update(label);
      }
      this.$message({
        message: "请输入中文，英文或数字",
        type: "warning",
        duration: 3000,
      });
    },
    /* 标签删除事件 */
    delTag({ tag: label, resolve }) {
      new Promise((resolve, reject) => {
        Modal.confirm({
          title: "提示",
          content: "是否确定移除标签？",
          type: "warning",
          onOk() {
            resolve();
          },
          onCancel() {
            reject();
          }
        });
      }).then(() => {
        let id = this.selectMaterial.id;
        resolve(this.material_tags_delete(id, label));
      }).catch(() => { });
    },
    /* 更新标签请求 */
    async material_tags_update(id, label) {
      let res = await this.updateMateriaTag({ id, label });
      this.dataList.forEach(item => {
        if (id === item.id) {
          this.$set(item, 'label', res);
        }
      });
      this.$emit('tagupdate');
    },
    /* 批量更新标签请求 */
    async material_batch_tags_update(label) {
      let res = await this.batchUpdateMateriaTag({ id: this.selectIds, label });
      if (res) {
        this.$message({
          message: "标签添加成功",
          type: "success",
          duration: 3000
        });
        this.batchTags = this.batchTags.filter(tag => tag !== label).concat(label);
        this.$emit('tagupdate');
      }
    },
    /* 标签联想搜索 */
    async material_tags_search(name) {
      if (!name) {
        this.tags_option_list = [];
      } else {
        let res = await this.searchMateriaTag({ name });
        this.tags_option_list = res;
      }
    },
    async material_tags_delete(id, label) {
      let res = await this.delMateriaTag({ id, label });
      if (res) {
        this.$message({
          message: "标签移除成功",
          type: "success",
          duration: 3000
        });

        this.dataList.forEach(item => {
          if (id === item.id) {
            this.$set(item, 'label', item.label.filter(lb => lb !== label));
          }
        });
      }
    },
    material_size(size) {
      if (size < 1024) {
        return size + 'B'
      } else if (size >= 1024 && size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + 'KB'
      } else if (size >= 1024 * 1024 && size < 1024 * 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + 'M'
      } else {
        return (size / 1024 / 1024 / 1024).toFixed(2) + 'G'
      }
    },
    /**
     * @param{DragEvent}e
     */
    handleDragStart(e, item) {
      e.dataTransfer.setData('application/json', JSON.stringify(item));
      // console.log(e.dataTransfer.getData('application/json'));
    }
  },
  computed: {
    ...mapState(["currentSubmenu", "myMateriaCheckedList", "myMateriaChecked"]),
    list() {
      return this.dataList
        .map((item) => ({
          ...item,
          is_collect:
            item.id in this.likeLookup
              ? this.likeLookup[item.id]
              : item.is_collect,
        }));
    },
    currentTagsList() {
      let id = this.selectMaterial.id;
      if (id) {
        let tags = [];
        this.list.some(item => {
          if (id === item.id) {
            tags = item.label;
            return true;
          }
          return false;
        });
        return tags;
      }
      return this.batchTags;
    }
  },
  watch: {
    tagVisible(val) {
      if (!val) {
        this.selectMaterial = {};
        this.batchTags = [];
      }
    }
  }
};
</script>

<style scoped>
.list-item:hover .tem_used_icon,
.tem_used_icon.block {
  display: block;
}
.tem_used_icon {
  display: none;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}

.material-prop-label {
  text-align: right;
}

.material-selection-marker {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: 0.2s;
}
.material-selection-marker--checked {
  box-shadow: inset 0 0 0 2px #007eff;
}
.material-selection-marker--hidden {
  visibility: hidden;
  opacity: 0;
}
.material-check {
  position: absolute;
  top: 4px;
  left: 6px;
  transition: 0.2s;
}
.material-check--hidden {
  visibility: hidden;
  opacity: 0;
}
</style>

<style>
.list-item:hover .material-action-trigger {
  opacity: 0.6;
}

.list-item .material-action-trigger:hover {
  opacity: 1;
}
</style>
